module.exports = __webpack_public_path__ + "static/media/simple.53e91ca7.JPG";